module.exports = "<!--<div class=\"categoryMenu\">-->\r\n<!--    <div class=\"cont\">-->\r\n<!--        <span class=\"shop_header_title\">{{title}}</span>-->\r\n<!--        <div class=\"shop_header_button\" data-bind=\"visible:btnText!=null\">-->\r\n<!--            我的申请({{btnText}})-->\r\n<!--        </div>-->\r\n<!--    </div>-->\r\n<!--</div>-->\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/template/HeadTitle.html
// module id = 98
// module chunks = 0